

import React, { useState, useEffect } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css"; 
export function MyEditor({ initialData, onDataChange }) {
  const [editorLoaded, setEditorLoaded] = useState(false);
  const [value, setValue] = useState(initialData || "<p></p>");
 
  useEffect(() => {
    setEditorLoaded(true);
  }, []);
  useEffect(() => {
    if (initialData) {
      setValue(initialData);
    }
  }, [initialData]);
  // Toolbar options similar to your CKEditor config
  const modules = {
    toolbar: [
      [{ header: [1, 2, false] }],
      ["bold", "italic", "link", "blockquote"],
      [{ list: "ordered" }, { list: "bullet" }],
      ["undo", "redo"], // no native undo/redo in Quill, can be custom-added
      ["clean"],
    ],
  };
 
  const formats = [
    "header",
    "bold",
    "italic",
    "link",
    "blockquote",
    "list",
    "bullet",
  ];
 
  return (
    <div className="ckeditor-container">
      {editorLoaded ? (
        <ReactQuill
          theme="snow"
          value={value}
          onChange={(content) => {
            setValue(content);
            if (onDataChange) {
              onDataChange(content); // same callback behavior
            }
          }}
          modules={modules}
          formats={formats}
          placeholder="Write your message..."
          style={{ minHeight: "200px" }}
        />
      ) : (
        <div className="text-center py-4">
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading editor...</span>
          </div>
        </div>
      )}
    </div>
  );
}
 